import { detectJobSource } from "@/lib/jobSource";
import { useT } from "@/lib/i18n";

/**
 * Small coloured pill showing which job-board a listing originated from
 * (LinkedIn, Indeed, Glassdoor, Adzuna, …). Used in the job-search result
 * cards. When the origin was aggregated *through* Adzuna we append a tiny
 * "via Adzuna" note so users understand the routing.
 */
export default function JobSourceBadge({ job, size = "sm" }) {
  const { t } = useT();
  const info = detectJobSource(job);
  const px = size === "sm" ? "px-2 py-0.5" : "px-2.5 py-1";
  const fs = size === "sm" ? "text-[0.6rem]" : "text-[0.65rem]";

  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`source-badge-${info.key}`}>
      <span
        className={`inline-flex items-center gap-1 font-mono uppercase tracking-[0.12em] text-white rounded-full ${px} ${fs}`}
        style={{ backgroundColor: info.color }}
      >
        {info.label}
      </span>
      {info.viaAdzuna && (
        <span className="font-mono text-[0.55rem] uppercase tracking-[0.12em] text-neutral-500">
          {t("jsBadgeVia")} Adzuna
        </span>
      )}
    </span>
  );
}
